import { Component, EventEmitter, OnInit, Output } from "@angular/core";

import { fadeInOut } from "src/app/animations/animations";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-game-page",
  templateUrl: "./game-page.component.html",
  styleUrls: ["./game-page.component.scss"],
  animations: [fadeInOut],
})
export class GamePageComponent implements OnInit {
  @Output() onRoute = new EventEmitter<void>();

  timer: any = { minutes: "01", seconds: "00" };
  timerValue: number = 60;
  score: number = 0;
  gameLoaded: boolean = false;
  loading: boolean = false;
  startGame: boolean = false;
  gameType: 0 | 1 = 0;
  state: "success" | "wrong" = "success";
  animationState: "visible" | "hidden" | null = null;
  stateTimer: any = null;
  stateImgTimer: any = null;

  ngOnInit(): void {
    const userPoints = localStorage.getItem(environment.storage);

    if (userPoints) this.changeRoute();
  }

  ngOnDestroy(): void {
    if (this.stateTimer) clearTimeout(this.stateTimer);
  }

  changeRoute() {
    this.onRoute.emit();
  }

  endGame(): void {
    localStorage.setItem(environment.storage, "" + this.score);
    localStorage.setItem(environment.storage + "-time", "" + this.timerValue);

    this.changeRoute();
  }

  timeCounter(time: number) {
    this.timerValue = time;
    const minutes = Math.floor(time / 60) % 60;
    const seconds = Math.floor(time % 60);

    this.timer.minutes = minutes.toString().padStart(2, "0");
    this.timer.seconds = seconds.toString().padStart(2, "0");
  }

  handleScore(score: number) {
    this.score = score;
    this.handleState("success");
  }

  handleWrong() {
    this.handleState("wrong");
  }

  handleState(nState: "success" | "wrong") {
    if (this.stateTimer) clearTimeout(this.stateTimer);

    this.state = nState;
    this.animationState = "visible";

    this.stateTimer = setTimeout(() => {
      this.stateTimer = null;
      this.animationState = "hidden";
    }, 1350);
  }
}
